module.exports = __webpack_public_path__ + "img/temp-home-02.4bc24caf.jpg";